export default __webpack_public_path__ + "static/dataunions-5d148ef2399908af814e13690b5b9bb6.png";